/* eslint-disable import-extensions/file-extension-required */
import { getUserPrivilegeFromQuery } from './getUserPrivilegeFromQuery';
import { UserPrivilege } from './UserPrivilege';

type GetIsProductOrSiteAdminFromQueryParam = {
	readonly isSiteAdmin?: boolean | null;
	readonly user?: {
		readonly confluence?: {
			readonly operations?: ReadonlyArray<
				| {
						readonly operation?: string | null;
						readonly targetType?: string | null;
				  }
				| null
				| undefined
			> | null;
		} | null;
	} | null;
} | null;

export function getIsProductOrSiteAdminFromQuery(
	queryData: GetIsProductOrSiteAdminFromQueryParam | undefined,
): boolean {
	const userPrivilege = getUserPrivilegeFromQuery(queryData);

	return (
		userPrivilege === UserPrivilege.PRODUCT_ADMIN || userPrivilege === UserPrivilege.SITE_ADMIN
	);
}
